import { render, staticRenderFns } from "./ButtonWhite.vue?vue&type=template&id=45a34710&scoped=true&"
import script from "./ButtonWhite.vue?vue&type=script&lang=js&"
export * from "./ButtonWhite.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWhite.vue?vue&type=style&index=0&id=45a34710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a34710",
  null
  
)

export default component.exports